import axios from 'axios';
import { config } from 'lib-shared-backend-config';

import { notificationActions } from 'components/notifications/actions/notification';

const { notificationAdd, notificationRemoveByType } = notificationActions;

let store;

export const setStoreAxios = (s) => {
  store = s;
};

/**
 * Sends a request to the `users` endpoint to check whether the user is an agent
 * or an end-user. We need to check for this because an agent can get demoted to
 * an end-user. If the request succeeds, we know that it's an agent and we can
 * show an unauthorized notification. Otherwise it's an end-user and we need to
 * redirect to an error page.
 */
let isVerifying = false;
export async function verifyPermissions(): Promise<void> {
  if (isVerifying) return; // Prevents issuing multiple requests.
  isVerifying = true;

  const profileId = store.getState().settings?.profile?.profile?.id;

  axios
    .request({
      baseURL: config.url.rest,
      url: `/v1/users/${profileId}`,
    })
    .then(() => dispatchUnauthorizedErrorNotification(store))
    .catch(() => dispatchRedirectToFailurePage(store))
    .finally(() => {
      isVerifying = false;
    });
}

/** Dispatches an action that redirects to a failure page. */
async function dispatchRedirectToFailurePage(store) {
  store.dispatch({
    type: 'app/error',
    payload: { error: { type: 'agentInsufficientRoles' } },
  });
}

/** Dispatches an unauthorized notification. */
async function dispatchUnauthorizedErrorNotification(store) {
  store.dispatch(notificationRemoveByType({ type: 'ajaxError' }));
  store.dispatch(
    notificationAdd({
      type: 'permissionDenied',
      title: 'Permission denied',
      text: 'You do not have permission to do that.',
      icon: 'info',
      className: 'warning',
    }),
  );
}
